export default __webpack_public_path__ + "static/media/hpbx2020.703c1b84.svg";